import React, { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { book } from '../../../routers/books';
import { useAppSelector } from '../../../store/hooks';
import { Hosts } from '../../../constants/hostName';

// Cross-sell under the bulk package selector — the mirror of MultipleJobListing
// (which promotes packs on the single Post-a-Job flow). The WHOLE strip is a
// router link to the single Post-a-Job flow (per-site route) for buyers who
// only need one listing. Styling reuses the shared .cpg-strip--cta pattern.
const SinglePostPromo = () => {
  const [postJobLink, setPostJobLink] = useState<string>(book.postAJob);
  const { siteNumber } = useAppSelector(({ pathnameSettings }) => ({
    siteNumber: pathnameSettings.siteNumber
  }));

  useEffect(() => {
    if (siteNumber) {
      switch (siteNumber) {
        case Hosts.NOSH:
          setPostJobLink(book.postAJobNosh);
          break;
        case Hosts.BREWBOUND:
          setPostJobLink(book.postAJobBrewbound);
          break;
        default:
          setPostJobLink(book.postAJob);
      }
    }
  }, [siteNumber]);

  return (
    <div className="cpg-promo-strip">
      <Link
        to={postJobLink}
        className="cpg-strip cpg-strip--cta"
      >
        <span className="cpg-strip__lead cpg-strip__lead--single">Just one job?</span>
        <span className="cpg-strip__copy">
          Post one 60-day listing across BevNET, Brewbound and Nosh, no pack
          required.
        </span>
        <span className="cpg-strip__go">Post a job →</span>
      </Link>
    </div>
  );
};

export default memo(SinglePostPromo);
